import {gsap} from "gsap";

export default () => {
  let blocks = document.querySelectorAll('.wp-block-accordion-image-with-text');

  if(blocks) {
    blocks.forEach(block => {
      let handle = block.querySelector('.accordion-handle');
      let itemsWrapper = block.querySelector('.accordion-items');
      let image = block.querySelector('.photo');
      let gapSize = 26;
      let itemSize = image.offsetHeight;
      let initialHeight = itemSize + gapSize;

      let tl = gsap.timeline({reversed: true, paused: true})
        .from(itemsWrapper, {height: initialHeight, duration: 0.5}, '-=1')
        .to(itemsWrapper, {height: '100%', duration: 0.1})

      handle.addEventListener('click', () => {
        tl.reversed() ? tl.play() : tl.reverse();
      })

      window.addEventListener("resize", resetTimeline);

      function resetTimeline() {
        let itemSize = image.offsetHeight;
        let initialHeight = itemSize + gapSize;
        itemsWrapper.style.height = initialHeight;

        tl.kill();
        tl = gsap.timeline({reversed: true, paused: true})
          .from(itemsWrapper, {height: initialHeight, duration: 0.5}, '-=1')
          .to(itemsWrapper, {height: '100%', duration: 0.1})
        tl.play();
        tl.pause();
      }
    })
  }
}
